import { Container, InlineBlock } from './styles'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'

export function PlanPrice( { valueKit } ) {
  return (
    <Container>
      <Typography
        as="h2"
        color="cinza600"
        fontWeight="xl"
        variant="heading1"
      >
        <InlineBlock>R$ { valueKit.toFixed( 2 ).replace( '.', ',' ) }</InlineBlock>
        <Typography
          as="span"
          color="cinza400"
          fontSizeDesktop="xs"
          fontSizeMobile="xs"
          fontWeight="l"
          variant="customText"
        >
          /mês <InlineBlock>+ taxa de entrega</InlineBlock>
        </Typography>
      </Typography>
    </Container>
  )
}

PlanPrice.propTypes = {
  'valueKit': PropTypes.number.isRequired,
}
